import { render, staticRenderFns } from "./CommentLikesModal.vue?vue&type=template&id=3b32de02&"
import script from "./CommentLikesModal.vue?vue&type=script&lang=ts&"
export * from "./CommentLikesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports